var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import { BigNumber, ethers } from "ethers";
import moment from "moment";
import { BaseLink, PrimaryText, SecondaryText, Title, } from "shared/lib/designSystem";
import { formatBigNumber, isPracticallyZero } from "shared/lib/utils/math";
import { v1ToV2MigrationMap, VaultAddressMap, VaultMaxDeposit, } from "shared/lib/constants/constants";
import { useVaultData } from "shared/lib/hooks/web3DataContext";
import { getVaultColor, isETHVault, isVaultFull } from "shared/lib/utils/vault";
import colors from "shared/lib/designSystem/colors";
import { getAssetDisplay } from "shared/lib/utils/asset";
import theme from "shared/lib/designSystem/theme";
import ButtonArrow from "shared/lib/components/Common/ButtonArrow";
import useTokenAllowance from "shared/lib/hooks/useTokenAllowance";
import SwapBTCDropdown from "./common/SwapBTCDropdown";
import useVaultActivity from "shared/lib/hooks/useVaultActivity";
import TooltipExplanation from "shared/lib/components/Common/TooltipExplanation";
import HelpInfo from "shared/lib/components/Common/HelpInfo";
import useVaultAccounts from "shared/lib/hooks/useVaultAccounts";
import useVaultActionForm from "../../../hooks/useVaultActionForm";
import { ACTIONS } from "./Modal/types";
import VaultV1TransferForm from "./v1/VaultV1TransferForm";
import VaultApprovalForm from "./common/VaultApprovalForm";
import VaultBasicAmountForm from "./common/VaultBasicAmountForm";
import { MigrateIcon } from "shared/lib/assets/icons/icons";
import { ActionButton } from "shared/lib/components/Common/buttons";
import { getVaultURI } from "../../../constants/constants";
var _a = ethers.utils, parseUnits = _a.parseUnits, formatUnits = _a.formatUnits;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n"])), function (props) {
    return props.variant === "mobile" &&
        "\n    height: 100%;\n    align-items: center;\n    justify-content:center;\n  ";
});
var FormContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: VCR, sans-serif;\n  color: #f3f3f3;\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: ", ";\n  background: ", ";\n  z-index: 1;\n"], ["\n  font-family: VCR, sans-serif;\n  color: #f3f3f3;\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: ", ";\n  background: ", ";\n  z-index: 1;\n"])), theme.border.radius, colors.background.two);
var FormContainerExtra = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", "0a;\n  margin-top: -20px;\n  border: ", " ", " ", ";\n  border-radius: ", ";\n  text-align: center;\n  z-index: 0;\n\n  ", "\n"], ["\n  background: ", "0a;\n  margin-top: -20px;\n  border: ", " ", " ", ";\n  border-radius: ", ";\n  text-align: center;\n  z-index: 0;\n\n  ", "\n"])), colors.primaryText, theme.border.width, theme.border.style, colors.border, theme.border.radius, function (props) {
    switch (props.variant) {
        case "desktop":
            return "padding: 32px 24px 16px 24px;";
        case "mobile":
            return "padding: 24px 24px 12px 24px;";
    }
});
var FormContainerExtraText = styled(PrimaryText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n"])));
var FormTitleContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  justify-content: space-evenly;\n  position: relative;\n\n  &:before {\n    display: block;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    content: \" \";\n    z-index: -1;\n  }\n"], ["\n  justify-content: space-evenly;\n  position: relative;\n\n  &:before {\n    display: block;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    content: \" \";\n    z-index: -1;\n  }\n"])));
var FormTitleDiv = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  padding: 24px 0;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:after {\n    background-color: white;\n  }\n\n  &:first-child {\n    border-top-left-radius: 8px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 8px;\n  }\n"], ["\n  width: 100%;\n  padding: 24px 0;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:after {\n    background-color: white;\n  }\n\n  &:first-child {\n    border-top-left-radius: 8px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 8px;\n  }\n"])), function (props) {
    return props.active ? "none" : "rgba(255,255,255,0.04)";
});
var FormTitle = styled(Title)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  text-transform: uppercase;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  text-transform: uppercase;\n  color: ", ";\n"])), function (props) { return (props.active ? "#f3f3f3" : "rgba(255, 255, 255, 0.64)"); });
var ContentContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n"], ["\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n"])));
var WalletBalance = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  font-size: 14px;\n  line-height: 20px;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  font-size: 14px;\n  line-height: 20px;\n  text-transform: uppercase;\n\n  ", "\n"])), function (props) {
    switch (props.state) {
        case "active":
            return "\n          color: \"#FFFFFFA3\";\n        ";
        case "inactive":
            return "\n          color: rgba(255, 255, 255, 0.16);\n        ";
        case "vaultFull":
            return "\n          color: " + colors.red + "\n        ";
        case "error":
            return "\n          color: " + colors.red + ";\n          font-family: \"Inter\", sans-serif;\n          text-transform: none;\n        ";
        default:
            return "\n          color: rgba(255, 255, 255, 0.16);\n        ";
    }
});
var SwapTriggerContainer = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var SwapTriggerButton = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin-top: 24px;\n  border: ", " ", " ", ";\n  border-radius: 100px;\n  padding: 8px 16px;\n  width: 300px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin-top: 24px;\n  border: ", " ", " ", ";\n  border-radius: 100px;\n  padding: 8px 16px;\n  width: 300px;\n  display: flex;\n  align-items: center;\n"])), theme.border.width, theme.border.style, colors.border);
var SwapTriggerButtonText = styled(SecondaryText)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var MigrateLogoContainer = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 100px;\n  background: ", "14;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 100px;\n  background: ", "14;\n"])), function (props) { return props.color; });
var MigrationTitle = styled(Title)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  font-size: 22px;\n  line-height: 28px;\n  letter-spacing: 1px;\n"], ["\n  font-size: 22px;\n  line-height: 28px;\n  letter-spacing: 1px;\n"])));
var MigrationDescription = styled(PrimaryText)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"])), colors.text);
var MigrationDescriptionHighlight = styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.primaryText);
var PillButton = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  padding: 10px 16px;\n  border: ", " ", " ", ";\n  border-radius: 100px;\n"], ["\n  padding: 10px 16px;\n  border: ", " ", " ", ";\n  border-radius: 100px;\n"])), theme.border.width, theme.border.style, colors.border);
var VaultV1ActionsForm = function (_a) {
    var variant = _a.variant, vaultOption = _a.vaultOption, onFormSubmit = _a.onFormSubmit;
    var color = getVaultColor(vaultOption);
    var _b = useVaultData(vaultOption), status = _b.status, userAssetBalance = _b.userAssetBalance, deposits = _b.deposits, vaultLimit = _b.vaultLimit, vaultBalanceInAsset = _b.vaultBalanceInAsset, maxWithdrawAmount = _b.maxWithdrawAmount, asset = _b.asset, decimals = _b.decimals, vaultMaxWithdrawAmount = _b.vaultMaxWithdrawAmount;
    var _c = useVaultActionForm(vaultOption), canTransfer = _c.canTransfer, handleActionTypeChange = _c.handleActionTypeChange, handleMaxClick = _c.handleMaxClick, vaultActionForm = _c.vaultActionForm;
    var vaultAccounts = useVaultAccounts("v1").vaultAccounts;
    var _d = useWeb3Wallet(), active = _d.active, account = _d.account;
    // state hooks
    var isLoadingData = status === "loading";
    var _e = useState(false), showTokenApproval = _e[0], setShowTokenApproval = _e[1];
    var tokenAllowance = useTokenAllowance(isETHVault(vaultOption) ? undefined : asset.toLowerCase(), VaultAddressMap[vaultOption].v1);
    var _f = useState(false), swapContainerOpen = _f[0], setSwapContainerOpen = _f[1];
    var activities = useVaultActivity(vaultOption).activities;
    var allowanceStr = tokenAllowance === null || tokenAllowance === void 0 ? void 0 : tokenAllowance.toString();
    // Calculate the latest option short position
    var withdrawalFreeUpTime = useMemo(function () {
        var sortedActivities = activities
            .filter(function (activity) { return activity.type === "minting"; })
            .sort(function (a, b) { return (a.date.valueOf() < b.date.valueOf() ? 1 : -1); });
        if (sortedActivities.length <= 0) {
            return "coming Friday";
        }
        return moment(sortedActivities[0].expiry, "X")
            .add(2, "hours")
            .format("MMMM Do, YYYY");
    }, [activities]);
    /**
     * Default to deposit at v1
     */
    useEffect(function () {
        handleActionTypeChange(ACTIONS.deposit, "v1");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Show token approval when needed
    useEffect(function () {
        if (allowanceStr &&
            BigNumber.from(allowanceStr).isZero() &&
            !isETHVault(vaultOption)) {
            setShowTokenApproval(true);
            return;
        }
        setShowTokenApproval(false);
    }, [allowanceStr, vaultOption]);
    // derived states
    var vaultMaxDepositAmount = VaultMaxDeposit[vaultOption];
    var connected = Boolean(active && account);
    var isInputNonZero = parseFloat(vaultActionForm.inputAmount) > 0;
    /**
     * Error validation
     */
    var error = useMemo(function () {
        var vaultAccount = vaultAccounts[vaultOption];
        /** Check for error without input requirement */
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
                /** Vault full */
                if (isVaultFull(deposits, vaultLimit, decimals)) {
                    return "vaultFull";
                }
                /** Max deposited */
                if (vaultBalanceInAsset.gte(vaultMaxDepositAmount)) {
                    return "maxDeposited";
                }
                break;
            case ACTIONS.withdraw:
                /** Withdraw limit reached */
                if (!vaultBalanceInAsset.isZero() && maxWithdrawAmount.isZero()) {
                    return "withdrawLimitReached";
                }
                /** All balance staked */
                if (vaultAccount &&
                    !vaultAccount.totalBalance.isZero() &&
                    vaultAccount.totalBalance.eq(vaultAccount.totalStakedBalance)) {
                    return "allBalanceStaked";
                }
                break;
        }
        try {
            /** Check block with input requirement */
            if (isInputNonZero && !isLoadingData && connected) {
                var amountBigNumber = parseUnits(vaultActionForm.inputAmount, decimals);
                switch (vaultActionForm.actionType) {
                    case ACTIONS.deposit:
                        /** Insufficient balance */
                        if (amountBigNumber.gt(userAssetBalance)) {
                            return "insufficientBalance";
                        }
                        /** Check amount more than vault max deposit amount */
                        if (amountBigNumber.gt(vaultMaxDepositAmount.sub(vaultBalanceInAsset))) {
                            return "maxExceeded";
                        }
                        /** Check if deposit amount more than vault available */
                        if (amountBigNumber.gt(vaultLimit.sub(deposits))) {
                            return "capacityOverflow";
                        }
                        break;
                    case ACTIONS.withdraw:
                        /** Check if vault withdrawal hitting limit */
                        if (amountBigNumber.gt(maxWithdrawAmount) &&
                            amountBigNumber.lte(vaultBalanceInAsset)) {
                            return "withdrawLimitExceeded";
                        }
                        /** Check if amount staked when withdraw */
                        if (amountBigNumber.gt(maxWithdrawAmount) &&
                            vaultAccount &&
                            amountBigNumber.lte(vaultAccount.totalBalance)) {
                            return "withdrawAmountStaked";
                        }
                        /** Check if user has enough balance to withdraw */
                        if (amountBigNumber.gt(maxWithdrawAmount)) {
                            return "insufficientBalance";
                        }
                        break;
                }
            }
        }
        catch (err) {
            // Ignore, this happen when unable to parse input during first load bcuz of value from other assets
        }
    }, [
        connected,
        decimals,
        deposits,
        isInputNonZero,
        isLoadingData,
        maxWithdrawAmount,
        userAssetBalance,
        vaultAccounts,
        vaultActionForm,
        vaultBalanceInAsset,
        vaultLimit,
        vaultMaxDepositAmount,
        vaultOption,
    ]);
    var formWalletContent = useMemo(function () {
        var vaultAccount = vaultAccounts[vaultOption];
        var stakedAmountText = vaultAccount ? (_jsxs(_Fragment, { children: ["AVAILABLE TO WITHDRAW: ", formatBigNumber(maxWithdrawAmount, decimals), " ", getAssetDisplay(asset), _jsx(TooltipExplanation, { title: "AVAILABLE TO WITHDRAW", explanation: _jsxs(_Fragment, { children: ["You have staked", " ", formatBigNumber(vaultAccount.totalStakedBalance, decimals), " ", vaultOption, " tokens, leaving you with", " ", formatBigNumber(maxWithdrawAmount, decimals), " ", getAssetDisplay(asset), " available for withdrawal.", _jsx("br", {}, void 0), _jsx("br", {}, void 0), "To increase the amount available for withdrawal, you must unstake your ", vaultOption, " tokens from the staking pool."] }, void 0), renderContent: function (_a) {
                        var ref = _a.ref, triggerHandler = __rest(_a, ["ref"]);
                        return (_jsx(HelpInfo, __assign({ containerRef: ref }, triggerHandler, { children: "?" }), void 0));
                    } }, void 0)] }, void 0)) : (_jsx(_Fragment, {}, void 0));
        switch (error) {
            case "vaultFull":
                return "The Vault is currently full";
            case "maxDeposited":
                return "This vault has a max deposit of " + parseInt(formatUnits(vaultMaxDepositAmount, decimals)).toLocaleString() + " " + getAssetDisplay(asset) + " per depositor";
            case "allBalanceStaked":
                return "You have staked all your " + vaultOption + " tokens. You must unstake your " + vaultOption + " tokens before you can withdraw from the vault.";
            case "withdrawLimitReached":
                return "The vault\u2019s weekly withdrawal limit has been reached. Withdrawals\n          will be enabled again at 1000 UTC on " + withdrawalFreeUpTime + ".";
            case "withdrawLimitExceeded":
                return (_jsxs(_Fragment, { children: ["Weekly Withdraw Limit:", " ", formatBigNumber(maxWithdrawAmount, decimals), " ", getAssetDisplay(asset), _jsx(TooltipExplanation, { title: "WEEKLY WITHDRAWAL LIMIT", explanation: "Withdrawing " + formatBigNumber(maxWithdrawAmount, decimals) + " " + getAssetDisplay(asset) + " will result in the vault hitting its weekly withdrawal limit. If the withdrawal limit is reached, withdrawals will be disabled until " + withdrawalFreeUpTime + ".", renderContent: function (_a) {
                                var ref = _a.ref, triggerHandler = __rest(_a, ["ref"]);
                                return (_jsx(HelpInfo, __assign({ containerRef: ref }, triggerHandler, { children: "?" }), void 0));
                            } }, void 0)] }, void 0));
            case "withdrawAmountStaked":
                return stakedAmountText;
        }
        if (!account || isLoadingData) {
            return "---";
        }
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
                return "Wallet Balance: " + formatBigNumber(userAssetBalance, decimals) + " " + getAssetDisplay(asset);
            case ACTIONS.withdraw:
                var position = formatBigNumber(vaultBalanceInAsset, decimals);
                /**
                 * Condition to check withdraw is limited by staked
                 * 1. Max withdraw amount must match total balance
                 * 2. Staked amount is bigger than 0
                 */
                if (vaultAccount &&
                    vaultBalanceInAsset.eq(maxWithdrawAmount) &&
                    !vaultAccount.totalStakedShares.isZero()) {
                    return stakedAmountText;
                }
                /**
                 * Over here, we show unstaked position instead
                 */
                if (vaultAccount && !vaultAccount.totalStakedShares.isZero()) {
                    return (_jsxs(_Fragment, { children: ["unstaked position: ", position, " ", getAssetDisplay(asset), _jsx(TooltipExplanation, { title: "AVAILABLE TO WITHDRAW", explanation: _jsxs(_Fragment, { children: ["You have staked", " ", formatBigNumber(vaultAccount.totalStakedBalance, decimals), " ", vaultOption, " tokens, leaving you with ", position, " ", getAssetDisplay(asset), " unstaked balance.", _jsx("br", {}, void 0), _jsx("br", {}, void 0), "To increase the balance for withdrawal, you must unstake your ", vaultOption, " tokens from the staking pool."] }, void 0), renderContent: function (_a) {
                                    var ref = _a.ref, triggerHandler = __rest(_a, ["ref"]);
                                    return (_jsx(HelpInfo, __assign({ containerRef: ref }, triggerHandler, { children: "?" }), void 0));
                                } }, void 0)] }, void 0));
                }
                return "Your Position: " + position + " " + getAssetDisplay(asset);
        }
    }, [
        account,
        asset,
        decimals,
        error,
        isLoadingData,
        maxWithdrawAmount,
        userAssetBalance,
        vaultAccounts,
        vaultActionForm.actionType,
        vaultBalanceInAsset,
        vaultMaxDepositAmount,
        vaultOption,
        withdrawalFreeUpTime,
    ]);
    var actionButtonText = useMemo(function () {
        switch (error) {
            case "insufficientBalance":
                return "Insufficient Balance";
            case "withdrawLimitExceeded":
                return "WEEKLY LIMIT EXCEEDED";
            case "withdrawLimitReached":
                return "WithdrawALS DISABLED";
            case "capacityOverflow":
                return "Exceed Vault Balance";
            case "withdrawAmountStaked":
                return "AVAILABLE LIMIT EXCEEDED";
            case "maxExceeded":
                return "Maximum " + parseInt(formatUnits(vaultMaxDepositAmount, decimals)).toLocaleString() + " " + getAssetDisplay(asset) + " Exceeded";
        }
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
                if (isInputNonZero) {
                    return "Preview Deposit";
                }
                return "Deposit " + getAssetDisplay(asset);
            case ACTIONS.withdraw:
                if (isInputNonZero) {
                    return "Preview Withdrawal";
                }
                return "Withdraw " + getAssetDisplay(asset);
            case ACTIONS.transfer:
                return "Preview Transfer";
        }
        return "";
    }, [
        asset,
        decimals,
        error,
        isInputNonZero,
        vaultActionForm.actionType,
        vaultMaxDepositAmount,
    ]);
    var walletBalanceState = useMemo(function () {
        switch (error) {
            case "vaultFull":
            case "maxDeposited":
                return "vaultFull";
            case "withdrawLimitExceeded":
            case "withdrawAmountStaked":
            case "insufficientBalance":
            case "maxExceeded":
            case "capacityOverflow":
                return "active";
            case undefined:
                break;
            default:
                return "error";
        }
        return connected ? "active" : "inactive";
    }, [connected, error]);
    var formContent = useMemo(function () {
        /**
         * Approval before deposit
         */
        if (vaultActionForm.actionType === ACTIONS.deposit && showTokenApproval) {
            return _jsx(VaultApprovalForm, { vaultOption: vaultOption, version: "v1" }, void 0);
        }
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
            case ACTIONS.withdraw:
                return (_jsx(VaultBasicAmountForm, { vaultOption: vaultOption, error: error, onFormSubmit: onFormSubmit, actionButtonText: actionButtonText }, void 0));
            case ACTIONS.transfer:
                return (_jsx(VaultV1TransferForm, { vaultOption: vaultOption, vaultAccount: vaultAccounts[vaultOption], transferVaultData: {
                        vaultBalanceInAsset: vaultBalanceInAsset,
                        maxWithdrawAmount: maxWithdrawAmount,
                        vaultMaxWithdrawAmount: vaultMaxWithdrawAmount,
                    }, actionButtonText: actionButtonText, onFormSubmit: onFormSubmit }, void 0));
        }
    }, [
        actionButtonText,
        error,
        maxWithdrawAmount,
        onFormSubmit,
        showTokenApproval,
        vaultAccounts,
        vaultActionForm,
        vaultBalanceInAsset,
        vaultMaxWithdrawAmount,
        vaultOption,
    ]);
    var swapContainerTrigger = useMemo(function () {
        switch (asset) {
            case "WBTC":
                return (_jsx(SwapTriggerContainer, { children: _jsxs(SwapTriggerButton, __assign({ role: "button", onClick: function () { return setSwapContainerOpen(function (open) { return !open; }); } }, { children: [_jsx(SwapTriggerButtonText, { children: "Swap your BTC or renBTC for wBTC" }, void 0), _jsx(ButtonArrow, { isOpen: swapContainerOpen }, void 0)] }), void 0) }, void 0));
            default:
                return _jsx(_Fragment, {}, void 0);
        }
    }, [asset, swapContainerOpen]);
    var swapContainer = useMemo(function () {
        switch (asset) {
            case "WBTC":
                return _jsx(SwapBTCDropdown, { open: swapContainerOpen }, void 0);
            default:
                return _jsx(_Fragment, {}, void 0);
        }
    }, [asset, swapContainerOpen]);
    var handleWithdraw = useCallback(function () {
        handleActionTypeChange(ACTIONS.withdraw, "v1");
        handleMaxClick();
        onFormSubmit();
    }, [handleActionTypeChange, handleMaxClick, onFormSubmit]);
    var body = useMemo(function () {
        /**
         * Disabled Vault form body
         */
        if (!isLoadingData && !vaultLimit.isZero()) {
            var vaultAccount = vaultAccounts[vaultOption];
            var balanceToMigrate = vaultAccount
                ? vaultAccount.totalBalance
                : BigNumber.from(0);
            /**
             * If user has no remaining position
             */
            if (isPracticallyZero(balanceToMigrate, decimals)) {
                return (_jsxs("div", __assign({ className: "d-flex flex-column align-items-center p-4" }, { children: [_jsx(MigrateLogoContainer, __assign({ color: color, className: "mt-3" }, { children: _jsx(MigrateIcon, { color: color, height: 27 }, void 0) }), void 0), _jsx(MigrationTitle, __assign({ className: "mt-3" }, { children: "V1 VAULT INACTIVE" }), void 0), _jsx(MigrationDescription, __assign({ className: "mx-3 mt-2 text-center" }, { children: "V1 vaults are now inactive and do not accept deposits" }), void 0), _jsx(BaseLink, __assign({ to: getVaultURI(vaultOption, "v2"), className: "w-100" }, { children: _jsx(ActionButton, __assign({ color: color, className: "py-3 mt-4" }, { children: "SWITCH TO V2" }), void 0) }), void 0)] }), void 0));
            }
            /**
             * If user has remaining position
             */
            return (_jsxs("div", __assign({ className: "d-flex flex-column align-items-center p-4" }, { children: [_jsx(MigrateLogoContainer, __assign({ color: color, className: "mt-3" }, { children: _jsx(MigrateIcon, { color: color, height: 27 }, void 0) }), void 0), _jsx(MigrationTitle, __assign({ className: "mt-3" }, { children: (function () {
                            switch (vaultOption) {
                                case "rUSDC-ETH-P-THETA":
                                    return "SWITCH TO T-yvUSDC-P-ETH";
                                default:
                                    return "MIGRATE TO V2";
                            }
                        })() }), void 0), _jsxs(MigrationDescription, __assign({ className: "mt-3 text-center" }, { children: ["You can now move your V1 deposit balance of", " ", _jsxs(MigrationDescriptionHighlight, { children: [formatBigNumber(balanceToMigrate, decimals), " ", getAssetDisplay(asset)] }, void 0), " ", "to the V2 vault"] }), void 0), _jsx(BaseLink, __assign({ to: getVaultURI(v1ToV2MigrationMap[vaultOption], "v2"), className: "w-100" }, { children: _jsxs(ActionButton, __assign({ color: color, className: "py-3 mt-4" }, { children: ["MIGRATE ", getAssetDisplay(asset)] }), void 0) }), void 0), _jsx(SecondaryText, __assign({ className: "mt-3" }, { children: "OR" }), void 0), _jsx(PillButton, __assign({ className: "mt-3", role: "button", onClick: handleWithdraw }, { children: _jsxs(PrimaryText, { children: ["Withdraw ", getAssetDisplay(asset)] }, void 0) }), void 0)] }), void 0));
        }
        /**
         * Form body
         */
        return (_jsxs(_Fragment, { children: [_jsxs(FormTitleContainer, __assign({ className: "d-flex flex-row align-items-center" }, { children: [_jsx(FormTitleDiv, __assign({ active: vaultActionForm.actionType === ACTIONS.deposit, onClick: function () { return handleActionTypeChange(ACTIONS.deposit, "v1"); } }, { children: _jsx(FormTitle, __assign({ active: vaultActionForm.actionType === ACTIONS.deposit }, { children: "Deposit" }), void 0) }), void 0), _jsx(FormTitleDiv, __assign({ active: vaultActionForm.actionType === ACTIONS.withdraw, onClick: function () { return handleActionTypeChange(ACTIONS.withdraw, "v1"); } }, { children: _jsx(FormTitle, __assign({ active: vaultActionForm.actionType === ACTIONS.withdraw }, { children: "Withdraw" }), void 0) }), void 0), canTransfer && (_jsx(FormTitleDiv, __assign({ active: vaultActionForm.actionType === ACTIONS.transfer, onClick: function () { return handleActionTypeChange(ACTIONS.transfer, "v1"); } }, { children: _jsx(FormTitle, __assign({ active: vaultActionForm.actionType === ACTIONS.transfer }, { children: "Transfer" }), void 0) }), void 0))] }), void 0), _jsxs(ContentContainer, __assign({ className: "px-4 py-4" }, { children: [formContent, _jsx(WalletBalance, __assign({ state: walletBalanceState }, { children: formWalletContent }), void 0), swapContainerTrigger] }), void 0), swapContainer] }, void 0));
    }, [
        asset,
        canTransfer,
        color,
        decimals,
        formContent,
        formWalletContent,
        handleActionTypeChange,
        handleWithdraw,
        isLoadingData,
        swapContainer,
        swapContainerTrigger,
        vaultAccounts,
        vaultActionForm.actionType,
        vaultLimit,
        vaultOption,
        walletBalanceState,
    ]);
    var formExtra = useMemo(function () {
        var vaultAccount = vaultAccounts[vaultOption];
        var balanceToMigrate = vaultAccount
            ? vaultAccount.totalBalance
            : BigNumber.from(0);
        if (!isLoadingData &&
            vaultLimit.isZero() &&
            !isPracticallyZero(balanceToMigrate, decimals)) {
            return (_jsx(FormContainerExtra, __assign({ variant: variant }, { children: _jsx(FormContainerExtraText, __assign({ color: color }, { children: "IMPORTANT: Withdrawal fees do not apply for migrations from V1 to V2" }), void 0) }), void 0));
        }
        switch (vaultActionForm.actionType) {
            case ACTIONS.transfer:
                return (_jsx(FormContainerExtra, __assign({ variant: variant }, { children: _jsxs(FormContainerExtraText, __assign({ color: color }, { children: ["Vault transfers are ", _jsx("strong", { children: "FREE" }, void 0), ": withdrawal fees are waived when you migrate"] }), void 0) }), void 0));
        }
    }, [
        color,
        decimals,
        isLoadingData,
        variant,
        vaultAccounts,
        vaultOption,
        vaultLimit,
        vaultActionForm.actionType,
    ]);
    return (_jsxs(Container, __assign({ variant: variant }, { children: [_jsx(FormContainer, { children: body }, void 0), formExtra] }), void 0));
};
export default VaultV1ActionsForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;
//# sourceMappingURL=VaultV1ActionsForm.js.map